module.exports = __webpack_public_path__ + "static/media/gameUniformDesignOther.2710cf87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameUniformDesignOther.png
// module id = 2541
// module chunks = 0